export default {
    app_name: 'BlindTestMaster',
    version: '2.0.29',
    passKey: '1234',
    mqtt: {
        host: 'wss://broker.emqx.io:8084/mqtt',
        // clientId: 'blindtest_master',
        // host: 'ws://mqtt.jmco.ch:9001/mqtt',
        // port: 9001,
        // user: 'mqtt-user',
        // pass: 'KUQAg3Tqr4MsEn5'
        topic: 'blindtest/master/#',
    },
    masterTopic: 'blindtest/master',
    startKey: 'start',
    stopKey: 'stop',
    baseUrl: (process.env.NODE_ENV == "development") ?  "http://localhost:4000/api/" : "/api/",
}